import { apiErrorResolverMap } from '@/composables/apiErrorResolverMap'
import { resolveCode } from '@/composables/resolveCode'
import type { PresentationInstruction } from '@/composables/PresentationInstruction'
import type { TranslateFn } from '@/composables/TranslateFn'
import type { AppProblemModel } from '@/services/api/AppProblemModel'
import type { ApiErrorCode } from '@/services/api/generated'
import { retrySuffix } from './retrySuffix'

/**
 * The reason-resolved message for a normalized problem: resolves
 * `problem.reason` + `problem.params` through the locale-backed
 * `apiErrorResolverMap` instead of trusting `problem.detail`. Returns `null`
 * when the problem carries no `reason` (most problems today, since backend
 * reason coverage is still partial), so a caller falls back to
 * `problemMessage()` for those.
 */
export const problemReasonMessage = (problem: AppProblemModel, t: TranslateFn): string | null => {
  if (problem.reason === null) return null

  const instruction: PresentationInstruction<ApiErrorCode> = {
    code: problem.code,
    reason: problem.reason,
    ...(problem.params !== null ? { params: problem.params } : {})
  }

  return `${resolveCode(instruction, apiErrorResolverMap, t)}${retrySuffix(problem, t)}`
}
